<mat-toolbar color="primary" class="header" fxLayout="row" fxLayoutAlign="space-between center">
  <div class="mr-40">
    <span class="title">Festivali</span>
  </div>
  <div class="w-100">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="header-buttons">
      <a *appPermissions="[PermissionEnum.READ_EVENTS]" [routerLinkActive]="'orange-color'" class="accent-color"
        [routerLink]="'/home'">Inicio</a>
      <a *appPermissions="[PermissionEnum.READ_EVENTS]" [routerLinkActive]="'orange-color'" class="accent-color"
        [routerLink]="'/events'">Eventos</a>
      <a *appPermissions="[PermissionEnum.READ_USERS]" [routerLinkActive]="'orange-color'" class="accent-color"
        [routerLink]="'/users-tables'">Usuarios</a>
      <a *appPermissions="[PermissionEnum.READ_BOOKINGS]" [routerLinkActive]="'orange-color'" class="accent-color"
        [routerLink]="'/bookings'">Contrataciones</a>
      <a *appPermissions="[PermissionEnum.CONFIGURATION]" [routerLinkActive]="'orange-color'" class="accent-color"
        [routerLink]="'/profiles'">Perfiles</a>
      <a *appPermissions="[PermissionEnum.CONFIGURATION]" [routerLinkActive]="'orange-color'" class="accent-color"
        [routerLink]="'/configuration'">Configuración</a>
    </div>
  </div>
  <div>
    <button mat-button [matMenuTriggerFor]="menu">
      <app-avatar [avatar]="userAvatarUrl" [width]="50" [height]="50" [borderRadius]="50"></app-avatar>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>Perfil</button>
      <button mat-menu-item (click)="logout()">Logout</button>
    </mat-menu>
  </div>
</mat-toolbar>